import React from "react";
import { Stack, Pagination, PaginationItem } from "@mui/material";
import { useTranslation } from "react-i18next";


export default function CustomPagination({
  currentPage,
  totalPages,
  onPageChange,
  showFirstButton = true,
  showLastButton = true,
  color = "primary",
  spacing = 2,
  sx = { mt: 3 },
}) {
   const [t] = useTranslation();
  return (
    <Stack spacing={spacing} sx={sx} alignItems="center">
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={onPageChange}
        color={color}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            slots={{
              first: () => <span>&lt;&lt;</span>,
              previous: () => <span>{t("Prev")}</span>,
              next: () => <span>{t("Next")}</span>,
              last: () => <span>&gt;&gt;</span>,
            }}
          />
        )}
      />
    </Stack>
  );
}